import axios from 'axios'
import {Toast} from 'mint-ui';
import YunJi from '@/assets/js/YunJi'

const Http = (function() {
  const instance = axios.create({
    baseURL: '//' + globalConfig.ysappItemBasePath + '/yunjiysapp',
    withCredentials: true
  })
  
  instance.interceptors.response.use((res) => {
    return res.data
  }, (error) => {
    Toast('网络错误')
    return Promise.reject(error)
  })

  return instance
})()

/**
 * 三级类目
 */
export const getThirdCategory = (params) => Http.get('/app/categoryguide/queryThirdCategory.json', {params})
export const getListItemByCategoryId = (params) => Http.get('/app/categoryguide/getListItemByCategoryId.json', {params})
export const listFootPrint = (params) => Http.get('/app/listFootPrint.json', {params})